
import Modal from "@mui/material/Modal";
import InfoIconImgSrc from "../../assets/image/png/info.png";
import Fade from "@mui/material/Fade";

import { CircularProgress, TextField } from "@mui/material";
import CustomButton from "../../components/dms_common/CustomButton";
import { customSx } from "../../components/createSecondaryOrder/util";
import { EWayBillModalState } from "./ViewOrderType";
import { useEffect } from "react";

interface CustomPopupProps {
  message: string;
  leftButtonText: string;
  rightButtonText: string;
  onLeftButtonClick: () => void;
  onRightButtonClick: () => void;
  onClose?: () => void;
  loading?: boolean;
  eWayBillModalState: EWayBillModalState;
  setEWayBillModalState: React.Dispatch<React.SetStateAction<EWayBillModalState>>;
}

const customStyle = {
  width: 22,
  height: 22,
  color: "#fff",
  marginTop: "5px",
};

const EWayBillModal: React.FC<CustomPopupProps> = ({
  message,
  leftButtonText,
  rightButtonText,
  onLeftButtonClick,
  onRightButtonClick,
  onClose,
  loading,
  eWayBillModalState,   
  setEWayBillModalState 
}) => {

  useEffect(() => {
    // Define the keydown event handler
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl (Windows/Linux) or Meta (Mac) key
      if (!event.ctrlKey && !event.metaKey) {
        return;
      }

      const key = event.key.toLowerCase();

      // Prevent default behavior to avoid browser shortcuts
      event.preventDefault();

      // Handle Ctrl + A or ⌘ + A for left button
      if (key === "a" && leftButtonText && onLeftButtonClick && !loading) {
        console.log("Executing Ctrl + A for left button click");
        onLeftButtonClick();
      }

      // Handle Ctrl + X or ⌘ + X for right button
      if (key === "x" && rightButtonText && onRightButtonClick) {
        console.log("Executing Ctrl + X for right button click");
        onRightButtonClick();
      }
    };

    // Add event listener when modal is open
    if (eWayBillModalState.open) {
      window.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup event listener when modal closes or component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    eWayBillModalState.open,
    leftButtonText,
    rightButtonText,
    onLeftButtonClick,
    onRightButtonClick,
    loading,
  ]);

  return (
    <Modal
      open={eWayBillModalState.open}
      onClose={onClose}
      closeAfterTransition
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={eWayBillModalState.open}>
        <div
          className={"CustomGenericModal_popup-container"}
          style={{ width: "480px" }}
        >
          <div className="CustomGenericModal_popup-content">
            <div className="CustomGenericModal_popup-sign">
              {<img src={InfoIconImgSrc} />}
            </div>
            <div className="CustomGenericModal_popup-message">{message}</div>

            <div className="CustomGenericModal_transporterGstin">
              <span>Transporter GSTIN:</span>
              <TextField
                size="small"
                type="text"
                id="transporterGstin"
                required
                value={eWayBillModalState.data}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only alphanumeric characters
                  if (/^[a-zA-Z0-9]*$/.test(value)) {
                    const showValidationError =  eWayBillModalState.validationError ? value.length < 15 : false
                    setEWayBillModalState((prev) => ({ ...prev, data: value, validationError: showValidationError }));
                  }
                }}
                className="select_customer_textfield"
                sx={customSx}
                inputProps={{
                  maxLength: 15,
                }}
              />
            </div>

            <div
              className="CustomGenericModal_transporterGstin-error"
              style={{
                visibility: eWayBillModalState.validationError
                  ? "visible"
                  : "hidden",
              }}
            >
              <span>Transporter GSTIN should be 15 characters long</span>
            </div>

            <div className="CustomGenericModal_popup-buttons">
              {" "}
              {rightButtonText && onRightButtonClick && (
                <CustomButton
                  onClick={onRightButtonClick}
                  flexGrow={0.4}
                  fontColor="#707070"
                  backgroundColor="#fff"
                  borderColor="#707070"
                >
                  {rightButtonText}
                </CustomButton>
              )}
              {leftButtonText && onLeftButtonClick && (
                <CustomButton
                  onClick={onLeftButtonClick}
                  flexGrow={rightButtonText ? 0.4 : 1}
                >
                  {loading ? (
                    <CircularProgress style={customStyle} />
                  ) : (
                    leftButtonText
                  )}
                </CustomButton>
              )}
            </div>
          </div>
          {onClose && (
            <button
              className="CustomGenericModal_popup-close"
              onClick={onClose}
            >
              ×
            </button>
          )}
        </div>
      </Fade>
    </Modal>
  );
};

export default EWayBillModal;
